var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAboutIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 24,
    viewBox: "0 0 12 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1.40625C6.75 4.40625 7.20234 9.8467 8.25 11.1562C10.2378 13.641 12 14.9062 12 17.1562C12 18.6562 11.25 20.9062 9.75 22.4062V23.1562H2.25V22.4062C0.749906 20.9065 0 18.6562 0 17.1562C0 14.9062 1.76222 13.641 3.75 11.1562C4.79766 9.8467 5.25 4.40625 3.75 1.40625C6 0.65625 6 0.65625 8.25 1.40625Z",
    fill: "#113E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon5);
export default __webpack_public_path__ + "static/media/aboutIcon5.874f06f27a574b8d9e8394d055b5ab5c.svg";
export { ForwardRef as ReactComponent };